import React, { useState, useRef, useEffect } from 'react';
import { Phone, Car, ClipboardList, Briefcase } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';

const QuickLinks = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { language } = useLanguage();
    const t = translations[language].quickLinks;
    const containerRef = useRef(null);

    // Handle click outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const links = [
        { icon: <Phone size={20} />, label: t.contact, href: '/connect/contact-us' },
        { icon: <Car size={20} />, label: t.testDrive, href: '/test-drive' },
        { icon: <ClipboardList size={20} />, label: t.service, href: '/car-service' },
        { icon: <Briefcase size={20} />, label: t.careers, href: '/connect/careers' },
    ];

    return (
        <div ref={containerRef} className={`fixed top-1/2 transform -translate-y-1/2 z-50 flex items-center ${language === 'ar' ? 'left-0 flex-row-reverse' : 'right-0'}`}>
            {/* Expanded Content */}
            <div
                className={`bg-white shadow-xl ${language === 'ar' ? 'rounded-r-2xl' : 'rounded-l-2xl'} overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'w-48 opacity-100' : 'w-0 opacity-0'}`}
                style={{ height: 'auto' }}
            >
                <div className="flex flex-col py-4">
                    {links.map((link, index) => (
                        <Link
                            key={index}
                            to={link.href}
                            onClick={() => setIsOpen(false)}
                            className="flex items-center gap-3 px-6 py-3 text-gray-800 hover:bg-gray-50 hover:text-red-600 transition-colors whitespace-nowrap"
                        >
                            <span className="text-black">{link.icon}</span>
                            <span className="font-medium text-lg">{link.label}</span>
                        </Link>
                    ))}
                </div>
            </div>

            {/* Toggle Tab */}
            <button
                onClick={() => setIsOpen(!isOpen)}
                className={`bg-gray-900 text-white ${language === 'ar' ? 'rounded-r-full' : 'rounded-l-full'} py-8 px-2 flex flex-col items-center justify-center shadow-lg hover:bg-red-600 transition-colors`}
                style={{ writingMode: 'vertical-rl', textOrientation: 'mixed' }}
            >
                <span className="transform rotate-180 text-sm font-bold tracking-wider uppercase whitespace-nowrap">
                    {t.title}
                </span>
            </button>
        </div>
    );
};

export default QuickLinks;
